/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const LowSoundIndicatorIcon = ({
  width = 2,
  height = 6,
  color = '#fff',
  ...props
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 2 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.15005 0.193172C0.347282 -0.000100195 0.663848 0.00311035 0.85712 0.200343C1.56358 0.921281 2 1.91007 2 2.99978C2 4.0895 1.56358 5.07829 0.85712 5.79922C0.663848 5.99646 0.347282 5.99967 0.15005 5.8064C-0.0471821 5.61312 -0.0503927 5.29656 0.142879 5.09932C0.673603 4.55773 1 3.81737 1 2.99978C1 2.18219 0.673603 1.44184 0.142879 0.900242C-0.0503927 0.70301 -0.0471821 0.386444 0.15005 0.193172Z"
      fill={color}
    />
  </svg>
);

export default LowSoundIndicatorIcon;
